"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var AjtAppState_1 = require("./states/AjtAppState");

var mobx_react_1 = require("mobx-react");

var styles_1 = require("@material-ui/core/styles");

var notistack_1 = require("notistack");

var AppOpenUrl_1 = require("./components/AppOpenUrl");

var AppSnackBar_1 = require("./components/AppSnackBar");

var AppRouteListener_1 = require("./components/AppRouteListener");

var AppDialog_1 = require("./components/AppDialog");

var AppSizeMe_1 = require("./components/AppSizeMe");

require("typeface-roboto");

var react_helmet_1 = require("react-helmet");

var AjtApp =
/** @class */
function (_super) {
  __extends(AjtApp, _super);

  function AjtApp() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.appState = _this.props.appState || new AjtAppState_1.default();
    return _this;
  }

  AjtApp.prototype.render = function () {
    return React.createElement(react_router_dom_1.BrowserRouter, {
      basename: this.appState.config.urlBase
    }, React.createElement(mobx_react_1.Provider, {
      appState: this.appState
    }, React.createElement(styles_1.MuiThemeProvider, {
      theme: this.props.theme
    }, React.createElement(notistack_1.SnackbarProvider, {
      anchorOrigin: AppSnackBar_1.snackbarAnchorOrigin
    }, React.createElement(AppSizeMe_1.default, null, React.createElement(react_helmet_1.default, null, this.appState.pantState.navigatorTitle && React.createElement("title", null, this.appState.pantState.navigatorTitle)), React.createElement(AppRouteListener_1.default, null), this.props.children, React.createElement(AppOpenUrl_1.default, null), React.createElement(AppSnackBar_1.default, null), React.createElement(AppDialog_1.default, null))))));
  };

  AjtApp.defaultProps = {
    theme: styles_1.createMuiTheme()
  };
  AjtApp = __decorate([mobx_react_1.observer], AjtApp);
  return AjtApp;
}(React.Component);

exports.default = AjtApp;